<template>
  <HrPageLayout
    title="Employee Position Register"
    subtitle="View and export position and supervisor information for all employees."
    icon="👥"
    :breadcrumb-items="[
      { label: 'Dashboard', route: '/dashboard' },
      { label: 'Employee Register' },
      { label: 'Position Register' }
    ]"
  >
    <template #header-actions>
      <button class="hr-btn hr-btn-success" @click="exportToCsv" :disabled="loading || records.length === 0">
        <i class="bx bx-download"></i> Export to CSV
      </button>
    </template>

    <div class="hr-chart-card hr-mb-4">
      <div class="hr-chart-body hr-py-3">
        <div class="hr-search-wrap" style="max-width: 400px;">
          <input
            v-model="search"
            type="text"
            class="hr-input"
            placeholder="Search by name, emp no, department..."
            spellcheck="false"
          >
          <i class="bx bx-search-alt search-icon"></i>
        </div>
      </div>
    </div>

    <div class="hr-chart-card">
      <div class="hr-chart-body">
        <div class="hr-table-wrapper">
          <table class="hr-table hr-table-hover hr-table-striped">
            <thead>
              <tr>
                <th>Employee Name</th>
                <th>Emp No</th>
                <th>Department</th>
                <th>Position Title</th>
                <th>Supervisor / Reporting To</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="6" class="hr-text-center hr-py-4">
                  <div class="hr-spinner"></div>
                </td>
              </tr>
              <tr v-else-if="filteredRecords.length === 0">
                <td colspan="6" class="hr-text-center hr-py-4 hr-text-muted">
                  No records found
                </td>
              </tr>
              <tr v-for="(row, i) in filteredRecords" :key="i">
                <td>
                  <strong>{{ row.firstName }} {{ row.middleName || '' }} {{ row.lastName }}</strong>
                </td>
                <td><span class="hr-badge hr-badge-secondary">{{ row.empNo || '—' }}</span></td>
                <td>{{ row.departmentName || '—' }}</td>
                <td>{{ row.positionTitle || '—' }}</td>
                <td>{{ row.reportingTo || '—' }}</td>
                <td><span class="hr-badge hr-badge-info">{{ row.status || 'Active' }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </HrPageLayout>
</template>

<script>
import HrPageLayout from "@/components/hrActions/HrPageLayout.vue";
import { execute, authUrl } from "@/api";

export default {
  name: "EmployeePositionRegister",
  components: { HrPageLayout },
  data() {
    return {
      records: [],
      loading: false,
      search: ""
    };
  },
  computed: {
    filteredRecords() {
      const q = this.search.toLowerCase().trim();
      if (!q) return this.records;
      return this.records.filter(r => {
        const name = `${r.firstName} ${r.middleName || ''} ${r.lastName}`.toLowerCase();
        const empNo = (r.empNo || "").toLowerCase();
        const dept = (r.departmentName || "").toLowerCase();
        const pos = (r.positionTitle || "").toLowerCase();
        const rep = (r.reportingTo || "").toLowerCase();
        return name.includes(q) || empNo.includes(q) || dept.includes(q) || pos.includes(q) || rep.includes(q);
      });
    }
  },
  mounted() {
    this.loadRecords();
  },
  methods: {
    async loadRecords() {
      this.loading = true;
      try {
        const data = new FormData();
        data.append("function", "getAllEmployeePositions");
        const res = await execute(data, authUrl);
        if (res?.data?.success) {
          this.records = res.data.data?.records || res.data.records || [];
        }
      } catch (e) {
        console.error("Failed to load records:", e);
      } finally {
        this.loading = false;
      }
    },
    exportToCsv() {
      if (!this.filteredRecords.length) return;
      
      const headers = ["Employee Name", "Emp No", "Department", "Position Title", "Supervisor", "Status"];
      const rows = this.filteredRecords.map(r => [
        `"${((r.firstName || '') + ' ' + (r.middleName || '') + ' ' + (r.lastName || '')).trim().replace(/\\s+/g, ' ')}"`,
        `"${r.empNo || ''}"`,
        `"${r.departmentName || ''}"`,
        `"${r.positionTitle || ''}"`,
        `"${r.reportingTo || ''}"`,
        `"${r.status || 'Active'}"`
      ]);
      
      const csvContent = [
        headers.join(","),
        ...rows.map(e => e.join(","))
      ].join("\n");
      
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "employee_positions_register.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style scoped>
</style>
